import React from "react";
import { useAppSelector } from "../../redux/hooks";
import { AuthStatus, getAuthStatus } from "../../redux/reducers/auth";
import LoadingSpinner from "../LoadingSpinner";

type Props = {
  component: React.FC;
};

const AuthCheck: React.FC<Props> = ({ component: Component }) => {
  const auth_status = useAppSelector(getAuthStatus);

  if (auth_status === AuthStatus.Loading) {
    return <LoadingSpinner space={6} />;
  } else {
    return <Component />;
  }
};

export default AuthCheck;
